// extracted by mini-css-extract-plugin
export default {"fullWidth":"xh-z","hasStyledAspectRatio":"yh-z"};